import AcceptedElementsSection from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/AcceptedElementsSection';
import AutomaticSourcesSection from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/AutomaticSourcesSection';
import DocumentGroupEditActions from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/DocumentGroupEditActions';
import GroupIdentitySection from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/GroupIdentitySection';
import NextPreparationSection from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/NextPreparationSection';
import RefusalAlert from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/RefusalAlert';
import StagesSection from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/StagesSection';
import VersionBanner from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/VersionBanner';
import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import BackLink from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Shared/BackLink';
import ScreenHeading from '@UI/Pages/Administration/DocumentGroups/Shared/ScreenHeading';
import type OrganizationWorkflowView from '@UI/Store/OrganizationWorkflows/Views/OrganizationWorkflowView';
import { css } from '@emotion/react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag } from '@verclam/ui-kit';

const bodyStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	max-width: 56.25rem;
	width: 100%;
`;

type Props = {
	/** Null when composing a new group. */
	readonly workflow: OrganizationWorkflowView | null;
	readonly organizationId: number;
};

/** The group form: heading, version notice, refusal reason, then the four blocks and the footer actions. */
const DocumentGroupEditBody: React.FC<Props> = ({ workflow, organizationId }) => {
	const navigate = useNavigate();
	const { draft } = useWorkflowDraft();
	const isActive = workflow?.isActive ?? true;
	const title = draft.label.trim() === '' ? 'Nouveau groupe' : draft.label;

	const handleBackClick = React.useCallback(() => {
		navigate('/administration/document-groups');
	}, [navigate]);

	return (
		<div css={bodyStyle}>
			<BackLink label="Groupes de documents" onClick={handleBackClick} />
			<ScreenHeading
				title={title}
				chip={
					<Tag
						value={isActive ? 'Actif' : 'Archivé'}
						severity={isActive ? 'success' : 'secondary'}
						rounded
					/>
				}
			/>
			<VersionBanner workflow={workflow} />
			<RefusalAlert />
			<GroupIdentitySection />
			<AcceptedElementsSection />
			<AutomaticSourcesSection />
			<NextPreparationSection />
			<StagesSection />
			<DocumentGroupEditActions
				organizationId={organizationId}
				workflowKey={workflow?.key ?? null}
				workflowLabel={workflow?.label ?? title}
				isActive={isActive}
			/>
		</div>
	);
};

export default DocumentGroupEditBody;
